import React, { useState } from 'react';
import api from '../lib/api';
import '../styles/ai-theme.css';

export default function AdminRegisterPage() {
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setMsg(null); setErr(null);
    try {
      const res = await api.post('/accounts/admins/', form);
      setMsg(res.data.message || 'Admin created.');
      setForm({ username: '', email: '', password: '' });
    } catch (e2) {
      setErr(e2.response?.data || 'Failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ai-scope">
      <div className="ai-bg">
        <div className="center-screen">
          <div className="glass-card p-3 card-fixed">
            <div className="glass-header d-flex align-items-center justify-content-between">
              <h4 className="h-title m-0">Register Admin</h4>
              <span className="badge-soft">Staff role</span>
            </div>
            <div className="p-3">
              <p className="h-subtle mb-3">Create a new admin account.</p>
              {msg && <div className="alert alert-success py-2">{String(msg)}</div>}
              {err && <div className="alert alert-danger py-2">{typeof err === 'string' ? err : JSON.stringify(err)}</div>}
              <form onSubmit={submit} className="d-grid gap-3">
                <input
                  className="form-control input-ai"
                  name="username"
                  placeholder="Username"
                  value={form.username}
                  onChange={onChange}
                />
                <input
                  className="form-control input-ai"
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={form.email}
                  onChange={onChange}
                />
                <input
                  className="form-control input-ai"
                  type="password"
                  name="password"
                  placeholder="Password (min 8)"
                  value={form.password}
                  onChange={onChange}
                />
                <button className="btn-ai w-100" type="submit" disabled={loading}>
                  {loading ? 'Creating…' : 'Create Admin'}
                </button>
                <a className="btn-ai-ghost w-100 text-center" href="/admin">Back to Dashboard</a>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
